<app-common-modal-form
  header="Merge Individuals"
  icon="ic-bell-20"
  [isCustomFooter]="true"
  (close)="close()"
>
  <div class="body-container">
    <app-list-grid-client-side
      [colDefs]="$any(colDefs)"
      [rowData]="individualRecords"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [pagination]="individualRecords.length > 20"
      (select)="selectMainIndividual($event)"
      (gridReady)="onGridReady($event)"
    />
  </div>

  @if (selectedIndividualRecords.length != 1) {
    <div class="mt-2">
      <app-disclaimer icon="" color="orange">
        Select main individual to merge into
      </app-disclaimer>
    </div>
  }

  <footer class="custom-footer d-flex gap-24">
    <div class="button-row">
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        [class.btn-loading]="isMergeLoading"
        [disabled]="!selectedIndividualRecords.length || isMergeLoading"
        (click)="merge()"
      >
        <i class="icon ic-link-20"></i>
        <span>Merge</span>
      </button>

      <button
        type="button"
        class="btn btn-secondary d-flex align-items-center gap-2"
        [disabled]="isMergeLoading"
        (click)="close()"
      >
        <span>Cancel</span>
      </button>
    </div>
  </footer>
</app-common-modal-form>
